import React from "react"

import Layout from "../components/layout"
import MediaFeature from "../components/MediaFeature"
import ContactColumn from "../components/ContactColumn"
import Quote from "../components/Quote"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO
      title="Contact Us"
      description="Have a question for us? No problem. Get in touch today about our sales enablement and sales tracking software and we’ll do everything we can to assist you."
    />
    <MediaFeature
      filename="sale_cycle.png"
      content={
        <>
          <h1>Drop us a line</h1>
          <p>
            Have a question for us? No problem. Get in touch today about our
            sales enablement platform and we’ll do everything we can to assist
            you.
          </p>
          <h2>General enquiries</h2>
          <a href="mailto:hello@stackglobal.io">
            <h3>hello@stackglobal.io</h3>
          </a>
        </>
      }
    />
    <ContactColumn></ContactColumn>
    <Quote
      quote="After following the Stack process, we implemented a sales engine that resulted in us closing the year with 3X YoY growth, momentum that was carried into the next year. This clear, concise and focused sales process was a big part of our ability to be successful raising our Series A funding."
      position="Rasheed Hammouda"
      name="Co-Founder, CEO, BridgeFT"
      padding
    ></Quote>
  </Layout>
)

export default IndexPage
